import axios from 'axios';

export const logPolicyAction = async (
  policyId: number,
  actionType: string,
  description: string,
  changes?: any
) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) return;

    await axios.post(
      `${process.env.REACT_APP_API_URL}/api/policy-notes`,
      {
        policy_id: policyId,
        action_type: actionType,
        description,
        changes: changes || null
      },
      { headers: { Authorization: `Bearer ${token}` } }
    );
  } catch (err) {
    console.error('Failed to log policy action:', err);
  }
};